import { render, staticRenderFns } from "./DialogAnnounceListImport.vue?vue&type=template&id=c9060a88&scoped=true&"
import script from "./DialogAnnounceListImport.vue?vue&type=script&lang=js&"
export * from "./DialogAnnounceListImport.vue?vue&type=script&lang=js&"
import style0 from "./DialogAnnounceListImport.vue?vue&type=style&index=0&id=c9060a88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9060a88",
  null
  
)

export default component.exports